module.exports = __webpack_public_path__ + "static/img/8.636f922.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/sp/8.png
// module id = M4ay
// module chunks = 0